export function forceFileDownload(response: any, name: string) {
    const blob = new Blob([response]);
    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = name?.replace(/\s/g, '-');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
